import { render, staticRenderFns } from "./viewDeductMoney.vue?vue&type=template&id=35730e88&scoped=true&"
import script from "./viewDeductMoney.vue?vue&type=script&lang=js&"
export * from "./viewDeductMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35730e88",
  null
  
)

export default component.exports